"use client";

import React from 'react';

interface PopularGamesLoadingProps {
  isLoading: boolean;
  children: React.ReactNode;
}

const PopularGamesLoading: React.FC<PopularGamesLoadingProps> = ({ isLoading, children }) => {
  if (isLoading) {
    return (
      <div className="relative">
        <style jsx>{`
          .loading-card {
            background: linear-gradient(145deg, #ffffff, #f0f0f0);
            box-shadow: 20px 20px 60px #d9d9d9,
                        -20px -20px 60px #ffffff;
            border: none;
            animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
          }
          @keyframes pulse {
            0%, 100% {
              opacity: 1;
            }
            50% {
              opacity: 0.5;
            }
          }
          .loading-thumbnail {
            background: linear-gradient(90deg, #f0f0f0 25%, #e0e0e0 50%, #f0f0f0 75%);
            background-size: 200% 100%;
            animation: shimmer 1.5s infinite;
          }
          @keyframes shimmer {
            0% {
              background-position: -200% 0;
            }
            100% {
              background-position: 200% 0;
            }
          }
          .spinner {
            width: 50px;
            height: 50px;
            border: 4px solid #f3f3f3;
            border-top: 4px solid #ff8c00;
            border-radius: 50%;
            animation: spin 1s linear infinite;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            z-index: 10;
          }
          @keyframes spin {
            0% {
              transform: translate(-50%, -50%) rotate(0deg);
            }
            100% {
              transform: translate(-50%, -50%) rotate(360deg);
            }
          }
          .loading-overlay {
            position: absolute;
            inset: 0;
            background: rgba(255, 255, 255, 0.8);
            backdrop-filter: blur(2px);
            z-index: 5;
          }
        `}</style>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {[...Array(12)].map((_, index) => (
            <div key={index} className="loading-card rounded-xl h-full flex flex-col relative">
              <div className="loading-overlay" />
              <div className="spinner" />
              <div className="relative w-full aspect-[4/3] overflow-hidden flex-shrink-0">
                <div className="loading-thumbnail absolute inset-0" />
              </div>
              <div className="p-4 flex-grow flex flex-col justify-between">
                <div className="h-6 w-3/4 bg-gray-200 rounded animate-pulse mb-2" />
                <div className="flex gap-2">
                  <div className="h-4 w-16 bg-gray-200 rounded-full animate-pulse" />
                  <div className="h-4 w-16 bg-gray-200 rounded-full animate-pulse" />
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
  return <>{children}</>;
};

export default PopularGamesLoading; 